const pathUrl = {
  home: () => '/',
  videoDetail: (videoId = ':videoID') => `/videos/${videoId}`,
  videoByCategory: (videoCategory = ':videoCategory', videoID = ':videoID') => `/${videoCategory}/${videoID}`,
  videoCategory: (videoCategory = ':category') => `/${videoCategory}`
}

export default pathUrl